import * as React from "react";

const IconFacebook: React.FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      stroke="#3C773B"
      {...props}
    >
      <circle cx="16" cy="16" r="15.5" />
      <path
        d="M20.5 8.5H18.25C17.2554 8.5 16.3016 8.89509 15.5983 9.59835C14.8951 10.3016 14.5 11.2554 14.5 12.25V14.5H12.25V17.5H14.5V23.5H17.5V17.5H19.75L20.5 14.5H17.5V12.25C17.5 12.0511 17.579 11.8603 17.7197 11.7197C17.8603 11.579 18.0511 11.5 18.25 11.5H20.5V8.5Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { IconFacebook };
